import { PERMISSION_GROUPS, PERMISSIONS } from "context/auth/types";

const PERMISSION_GROUP_ARRAY = [
    {
        groupId: PERMISSION_GROUPS.Device,
        permissions: [
            PERMISSIONS.DeviceRead,
            PERMISSIONS.DeviceUpdate,
            PERMISSIONS.DeviceTransfer,
            PERMISSIONS.DeviceExport,
            PERMISSIONS.DeviceUnlock,
            PERMISSIONS.DeviceSecretsRead
        ]
    },
    {
        groupId: PERMISSION_GROUPS.Task,
        permissions: [
            PERMISSIONS.TaskCreate,
            PERMISSIONS.TaskRead,
            PERMISSIONS.TaskUpdate,
            PERMISSIONS.TaskRetry
        ]
    },
    {
        groupId: PERMISSION_GROUPS.TaskGroup,
        permissions: [PERMISSIONS.TaskGroupRead]
    },
    {
        groupId: PERMISSION_GROUPS.DeviceGroup,
        permissions: [
            PERMISSIONS.DeviceGroupCreate,
            PERMISSIONS.DeviceGroupRead,
            PERMISSIONS.DeviceGroupUpdate,
            PERMISSIONS.DeviceGroupDelete
        ]
    },
    {
        groupId: PERMISSION_GROUPS.File,
        permissions: [
            PERMISSIONS.FileCreate,
            PERMISSIONS.FileRead,
            PERMISSIONS.FileUpdate,
            PERMISSIONS.FileDelete,
            PERMISSIONS.FileDownload,
            PERMISSIONS.FileTctWebAccess
        ]
    },
    {
        groupId: PERMISSION_GROUPS.Company,
        permissions: [
            PERMISSIONS.CompanyCreate,
            PERMISSIONS.CompanyUpdate,
            PERMISSIONS.CompanyDelete,
            PERMISSIONS.CompanyMerge
        ]
    },
    {
        groupId: PERMISSION_GROUPS.User,
        permissions: [
            PERMISSIONS.UserCreate,
            PERMISSIONS.UserRead,
            PERMISSIONS.UserUpdate,
            PERMISSIONS.UserDelete
        ]
    },
    {
        groupId: PERMISSION_GROUPS.Role,
        permissions: [
            PERMISSIONS.RoleCreate,
            PERMISSIONS.RoleRead,
            PERMISSIONS.RoleUpdate,
            PERMISSIONS.RoleDelete
        ]
    },
    {
        groupId: PERMISSION_GROUPS.Token,
        permissions: [
            PERMISSIONS.TctIntegrationAccess,
            PERMISSIONS.TokenCreate,
            PERMISSIONS.TokenRead,
            PERMISSIONS.TokenDelete
        ]
    }
];

export { PERMISSION_GROUP_ARRAY };
